import _ from 'lodash';

export class MetaUtil {

  public metaToEntryList(meta:Record<string, string | number | boolean | string[] | number[]>):MetaEntry[] {

    // we crete the local entry list
    const retList:MetaEntry[] = [];

    if(meta === undefined || Object.keys(meta).length === 0)
      return retList;
    
    for (const [key, value] of Object.entries(meta)) {

      if(_.isArray(value))
        retList.push({label: key, valueList:(value as string[]).map(value => '' + value)});
      else
        retList.push({label: key, valueList:['' + value]});
    }

    return retList;
  }

  public entryListToMeta(entryList:MetaEntry[]):Record<string, string | number | boolean | string[] | number[]> {

    let ret:Record<string, string | number | boolean | string[] | number[]> = {};

    for(let entry of entryList) {

      // we remove empty entries just in case
      entry.valueList = entry.valueList.filter(entry => entry.trim() !== '');

      // we ignore labels and values that are empty
      if(entry.label.trim() === '' || entry.valueList.length === 0)
        continue;

      // if single value
      if(entry.valueList.length === 1) {
        ret[entry.label] = this.castValue(entry.valueList[0]);
        continue;
      }
      
      // if it's a list instead => we need to check if it's a list of numbers, otherwise a list of strings is OK
      const numberList = entry.valueList
        .map(entry => this.castValue(entry))
        .filter(entry => typeof entry === 'number')
        
      if(numberList.length === entry.valueList.length) {
        ret[entry.label] = numberList as number[];
        continue;
      }

      // it's a list of strings, let's keep it as such
      ret[entry.label] = entry.valueList;
    }

    return ret;
  }

  public castValue(value:string):boolean | string | number {

    // a true or false => return a boolean
    if(value.toLowerCase() === 'true' || value.toLowerCase() === 'false')
      return value === 'true' ? true : false;

    const convToNum = parseFloat(value);

    // we convert to a number
    if(!isNaN(convToNum) && isFinite(convToNum) && (`` + convToNum) === value)
      return convToNum;

    // we give up it's a string
    return value;
  }
}

export interface MetaEntry {
  label:string;
  valueList:string[];
}